const TERMINAL_HOLOS_STATUSES = new Set([
  "COMPLETED",
  "FAILED",
  "REJECTED_UNSUPPORTED",
]);

function isCurrentCompletedHolosJob(job, cropYearVersionId) {
  return (
    job?.status === "COMPLETED" &&
    job.input_dependencies_current !== false &&
    (cropYearVersionId == null ||
      String(job.crop_year_version_id) === String(cropYearVersionId))
  );
}

async function waitForTerminalHolosJob({
  initialJob,
  fetchJob,
  delay = (milliseconds) =>
    new Promise((resolve) => setTimeout(resolve, milliseconds)),
  intervalMs = 5000,
  maxPolls = 72,
}) {
  let job = initialJob;
  for (let poll = 0; poll <= maxPolls; poll += 1) {
    if (job && TERMINAL_HOLOS_STATUSES.has(job.status)) {
      return job;
    }
    if (poll === maxPolls) break;
    await delay(intervalMs);
    job = await fetchJob();
  }
  throw new Error("The Holos calculation did not finish within six minutes.");
}

function holosJobFailureMessage(job) {
  if (job?.last_error) return job.last_error;
  if (job?.status === "REJECTED_UNSUPPORTED") {
    return "Holos does not support the saved crop-year inputs.";
  }
  return "The Holos calculation could not be completed. Review the crop-year inputs and try again.";
}

export {
  holosJobFailureMessage,
  isCurrentCompletedHolosJob,
  waitForTerminalHolosJob,
};
